export default __webpack_public_path__ + "assets/models/3d47ba328052824c52e4712b10dbc091.glb";